var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "next-app",
      on: {
        wheel: function ($event) {
          $event.preventDefault()
          return _vm.onWheel.apply(null, arguments)
        },
        touchstart: _vm.onTouchStart,
        touchend: _vm.onTouchEnd,
      },
    },
    [
      _c("header", { staticClass: "next-header" }, [
        _c("div", { staticClass: "header-gradient" }),
        _vm._v(" "),
        _c("div", { staticClass: "header-inner" }, [
          _c("a", { staticClass: "logo-area", attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "logo-icon",
              attrs: { src: _vm.logoImg, alt: "ChaCha" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "logo-text" }, [_vm._v("ChaCha")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header-app-wrap" }, [
            _c(
              "a",
              {
                staticClass: "header-app-btn",
                attrs: { href: "javascript:;" },
              },
              [
                _c("img", {
                  staticClass: "download-icon",
                  attrs: {
                    src: require("../../common/imgs/icon-download.png"),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("App")]),
                _vm._v(" "),
                _c("div", { staticClass: "download-tooltip" }, [
                  _c("ul", [
                    _c("li", { staticClass: "ios" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.appStoreUrl,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "dl-link-icon",
                            attrs: { src: _vm.iconApple, alt: "" },
                          }),
                          _vm._v(
                            "\n                  Apple Store\n                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "android" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.googlePlayUrl,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "dl-link-icon",
                            attrs: { src: _vm.iconGoogle, alt: "" },
                          }),
                          _vm._v(
                            "\n                  Google Play\n                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-layer" },
        _vm._l(_vm.slides, function (slide, idx) {
          return _c(
            "div",
            {
              key: "bg-" + idx,
              staticClass: "bg-item",
              class: { active: _vm.currentIndex === idx },
            },
            [_c("div", { staticClass: "bg-gradient", class: slide.bgClass })]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "content-inner" }, [
          _c(
            "div",
            { staticClass: "text-col" },
            _vm._l(_vm.slides, function (slide, idx) {
              return _c(
                "div",
                {
                  key: "txt-" + idx,
                  staticClass: "text-block",
                  class: { active: _vm.currentIndex === idx },
                },
                [
                  _c("h1", { staticClass: "slide-title" }, [
                    _vm._v(_vm._s(slide.title)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "slide-subtitle" }, [
                    _vm._v(_vm._s(slide.subtitle)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dl-buttons" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dl-btn",
                        attrs: {
                          href: _vm.appStoreUrl,
                          target: "_blank",
                          rel: "noopener",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "dl-btn-icon",
                          attrs: { src: _vm.iconApple, alt: "" },
                        }),
                        _vm._v(" "),
                        _vm._m(0, true),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dl-btn",
                        attrs: {
                          href: _vm.googlePlayUrl,
                          target: "_blank",
                          rel: "noopener",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "dl-btn-icon",
                          attrs: { src: _vm.iconGoogle, alt: "" },
                        }),
                        _vm._v(" "),
                        _vm._m(1, true),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "phone-col" }, [
            _c(
              "div",
              {
                staticClass: "phone-flipper phone-flipper-clickable",
                style: _vm.flipperStyle,
                attrs: {
                  role: "button",
                  tabindex: "0",
                  "aria-label": "Switch phone preview",
                },
                on: {
                  click: _vm.onPhoneClick,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onPhoneClick.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onPhoneClick.apply(null, arguments)
                    },
                  ],
                  transitionend: _vm.onFlipDone,
                },
              },
              [
                _c("div", { staticClass: "phone-card phone-front" }, [
                  _c("div", { staticClass: "phone-composite" }, [
                    _c("img", {
                      staticClass: "phone-img",
                      attrs: {
                        src: _vm.slides[_vm.displayFront].phone,
                        alt: "",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "phone-card phone-back" }, [
                  _c("div", { staticClass: "phone-composite" }, [
                    _c("img", {
                      staticClass: "phone-img",
                      attrs: {
                        src: _vm.slides[_vm.displayBack].phone,
                        alt: "",
                      },
                    }),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        _vm._l(_vm.slides, function (slide, idx) {
          return _c("span", {
            key: "dot-" + idx,
            staticClass: "dot",
            class: { active: _vm.currentIndex === idx },
            on: {
              click: function ($event) {
                return _vm.goTo(idx)
              },
            },
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "next-footer" }, [
        _c("div", { staticClass: "footer-inner" }, [
          _c("div", { staticClass: "footer-links" }, [
            _c("a", { attrs: { href: _vm.termsUrl, target: "_blank" } }, [
              _vm._v("Terms"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "divider" }, [_vm._v("|")]),
            _vm._v(" "),
            _c("a", { attrs: { href: _vm.privacyUrl, target: "_blank" } }, [
              _vm._v("Privacy"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "divider" }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "policies-menu",
                class: { open: _vm.showPolicies },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "policies-link",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.togglePolicies.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v("Policies\n            "),
                    _c("img", {
                      staticClass: "policies-chevron",
                      attrs: { src: _vm.iconChevron, alt: "" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPolicies,
                        expression: "showPolicies",
                      },
                    ],
                    staticClass: "policies-dropdown",
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.abuseUrl,
                          target: "_blank",
                          rel: "noopener",
                        },
                      },
                      [_vm._v("Sexual Abuse Support")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.abuseUrl + "#csam",
                          target: "_blank",
                          rel: "noopener",
                        },
                      },
                      [_vm._v("Child Safety Policy")]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "divider" }, [_vm._v("|")]),
            _vm._v(" "),
            _c("a", { attrs: { href: _vm.supportUrl, target: "_blank" } }, [
              _vm._v("Support"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "divider" }, [_vm._v("|")]),
            _vm._v(" "),
            _c("a", { attrs: { href: _vm.aboutUrl, target: "_blank" } }, [
              _vm._v("About ChaCha"),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dl-btn-text" }, [
      _c("small", [_vm._v("Download on the")]),
      _vm._v(" "),
      _c("strong", [_vm._v("App Store")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dl-btn-text" }, [
      _c("small", [_vm._v("GET IT ON")]),
      _vm._v(" "),
      _c("strong", [_vm._v("Google Play")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }